import React, { useState, useEffect, useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link } from 'react-router-dom';
import config from "../common/Config";
import Swal from 'sweetalert2';

const ReturnList = () => {
  const returnListRef = useRef(null);
  const accessToken = localStorage.getItem('accessToken');
  const [statusFilter, setStatusFilter] = useState('Pending');

  const getReturnList = () => {
    const $table = $(returnListRef.current);

    if ($.fn.DataTable.isDataTable($table)) {
      $table.DataTable().clear().destroy();
      $table.empty(); // Clear old table structure
    }

    // Append new thead dynamically
    const thead = `
      <thead>
        <tr>
          <th>Date</th>
          <th>Return No</th>
          <th>Customer (Ac/No)</th>
          <th>Grand Total</th>
          <th>Total Items</th>
          <th>Return By</th>
          <th>Status</th>
          ${statusFilter === 'Pending' ? '<th>Actions</th>' : ''}
        </tr>
      </thead>
    `;
    $table.append(thead);

    const columns = [
      { data: 'date' },
      {
        data: 'reference_no',
        render: (data, type, row) =>
          `<a href="${config.BASE_URL}/returns/view/${row.id}">${data}</a>`,
      },
      { data: 'company' },
      { data: 'grand_total' },
      { data: 'total_items' },
      { data: 'return_by' },
      { data: 'status' },
    ];

    if (statusFilter === 'Pending') {
      columns.push({
        data: null,
        render: (data, type, row) => `
          <div>
            <a href="javascript:void(0);" class="deductionbtn" data-id="${row.id}" data-action="accept" title="Accept Return"><i class="bi bi-check-square-fill"></i></a>
            <a href="javascript:void(0);" class="applybtn" data-id="${row.id}" data-action="reject" title="Reject Return"><i class="bi bi-sign-turn-right-fill"></i></a>
          </div>`
      });
    }

    $table.DataTable({
      processing: true,
      serverSide: true,
      ajax: {
        url: `${config.API_URL}/return/returnList_v2`,
        type: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: d => ({ ...d, status: statusFilter }),
        dataSrc: json => Array.isArray(json.data) ? json.data : [],
      },
      columns,
      columnDefs: [{ orderable: false, targets: '_all' }],
      pageLength: 10,
      drawCallback: () => {
        $(document).off('click', '.deductionbtn').on('click', '.deductionbtn', function (e) {
          const id = $(this).data('id');
          handelAcceptReject(id, 'accept');
        });
        $(document).off('click', '.applybtn').on('click', '.applybtn', function (e) {
          const id = $(this).data('id');
          handelAcceptReject(id, 'reject');
        });
      }
    });
  };

  const handelAcceptReject = async (id, action) => {
    const confirmMessage = action === 'accept'
      ? 'Are you sure you want to create the Credit Note?'
      : 'Are you sure you want to reject this order?';

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: confirmMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    });

    if (result.isConfirmed) {
      const url = action === 'accept'
        ? `${config.API_URL}/add_accept_return`
        : `${config.API_URL}/add_reject_return`;

      const formData = new FormData();
      formData.append('id', id);
      if (action === 'accept') {
        formData.append('allocation', 'yes');
      }

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        });

        const data = await response.json();
        if (data.success) {
          Swal.fire({
            title: "Success!",
            text: data.message || "Action completed successfully.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            getReturnList();
          });
        } else {
          Swal.fire({
            title: "Failed!",
            text: data.message || "An error occurred.",
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        console.error('API request failed:', error);
      }
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    $(document).off('click', '#returnStatusTabs .nav-link').on('click', '#returnStatusTabs .nav-link', function (e) {
      e.preventDefault();
      $('#returnStatusTabs .nav-link').removeClass('active');
      $(this).addClass('active');
      const selectedStatus = $(this).data('status');
      setStatusFilter(selectedStatus);
    });

    return () => {
      $(document).off('click', '#returnStatusTabs .nav-link');
    };
  }, []);

  useEffect(() => {
    getReturnList();
  }, [statusFilter]);

  return (
    <div>
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <Link to="/Dashboard"><i className="fa fa-home"></i></Link>
              <Link to="#">Return</Link>
              <Link to="#">Return List</Link>
            </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div>
                <div style={{ float: 'right' }}>
                  <a href={`${config.BASE_URL}/return/add_return`} className="create-catalogue-btn">Add Return</a>
                </div>

                <ul className="nav nav-tabs mb-3" id="returnStatusTabs">
                  <li className="nav-item">
                    <a className="nav-link active" href="#" data-status="Pending">Pending</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#" data-status="Accepted">Accepted</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#" data-status="Rejected">Rejected</a>
                  </li>
                </ul>

                <div className="show-order-area dashboard">
                  <div className="verical-scrl-wrapper returnlist-table" id="style-3">
                    <table className="table table-bordered dataTable resizable" id="returnListTable" ref={returnListRef}>
                      {/* thead will be inserted dynamically */}
                      <tbody></tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ReturnList;
